import ProductDescription from './ProductDescription'

const BSWholeWheatEnglishMuffinsProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '011BS',
  IsBroadband: true,
  Size: '',
}

export default BSWholeWheatEnglishMuffinsProduct
